import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { CeRequestOptions } from "../../request-creation/request-header/request-header.component";
import { RequestOptionsService } from "../services/request-options.service";

@Injectable()
export class RequestOptionsResolver implements Resolve<CeRequestOptions> {
  constructor(private requestOptionsService: RequestOptionsService) {}

  resolve(): Observable<CeRequestOptions> {
    return this.requestOptionsService.options();
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/resolvers/request-options-resolver.ts